/**
 * User role type
 */
export type UserRole = 'super_admin' | 'admin' | 'client';

/**
 * User role enum for backward compatibility
 */
export const UserRole = {
  SUPER_ADMIN: 'super_admin' as UserRole,
  ADMIN: 'admin' as UserRole,
  CLIENT: 'client' as UserRole,
};

/**
 * User document stored in Firestore
 */
export interface User {
  uid: string;
  email: string;
  name: string;
  role: UserRole;
  companyId: string;
  companyName: string;
  location?: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Input for creating a new user
 */
export interface UserCreateInput {
  email: string;
  password: string;
  name: string;
  role: UserRole;
  companyId: string;
  companyName: string;
  location?: string;
}

/**
 * Input for updating an existing user
 */
export interface UserUpdateInput {
  name?: string;
  role?: UserRole;
  companyId?: string;
  companyName?: string;
  location?: string;
}

/**
 * User with Firebase Auth data combined
 */
export interface AuthenticatedUser extends User {
  emailVerified: boolean;
}

/**
 * Response from user creation API
 */
export interface UserCreateResponse {
  success: boolean;
  userId: string;
  userData: User;
}

/**
 * Response from user update API
 */
export interface UserUpdateResponse {
  success: boolean;
  userId: string;
}

/**
 * Response from user delete API
 */
export interface UserDeleteResponse {
  success: boolean;
  userId: string;
}
